const config={

  "dropdowns":[
    {"title":"Navigation","rows":[
      {"title":"Home","url":"/"},     
      
    ]}  
  ]


  
}
export default config;
